import { createSelector } from '@ngrx/store';

import { AppState } from '../state';
import { ErrorModalModel } from './error-modal.model';
import { ErrorContent } from '@shared/services/content/_interfaces_/content.interface';

export const selectErrorModal = (state: AppState): ErrorModalModel => state.errorModal;
export const selectErrorModalVisibility = createSelector(selectErrorModal, ({ isVisible }: ErrorModalModel) => (isVisible = true));
export const selectErrorMessagesList = createSelector(selectErrorModal, ({ defaultContent }: ErrorModalModel) => defaultContent || []);
